import { RouteInterface } from '@/src/common/enums/routes'

export const CardPaymentsRoutes = {
  CardManagementPayment: {
    route: '/main/(tabs)/card/card-management/payment',
    name: 'Card Management - Payment',
    availableForDeepLinking: false,
  },
  CardManagementOneTimePayment: {
    route: '/main/(tabs)/card/card-management/payment/oneTimePayment',
    name: 'Card Management - One Time Payment',
    availableForDeepLinking: false,
  },
  CardManagementOneTimePaymentFundingSource: {
    route: '/main/(tabs)/card/card-management/payment/oneTimePayment/fundingSource',
    name: 'Card Management - One Time Payment Funding Source',
    availableForDeepLinking: false,
  },
  CardManagementOneTimePaymentConfirmation: {
    route: '/main/(tabs)/card/card-management/payment/oneTimePayment/confirmation',
    name: 'Card Management - One Time Payment Confirmation',
    availableForDeepLinking: false,
  },
  CardManagementOneTimePaymentSuccessful: {
    route: '/main/(tabs)/card/card-management/payment/oneTimePayment/paymentSuccessful',
    name: 'Card Management - One Time Payment Successful',
    availableForDeepLinking: false,
  },
  CardManagementAutoPay: {
    route: '/main/(tabs)/card/card-management/payment/autoPay',
    name: 'Card Management - Auto Pay',
    availableForDeepLinking: false,
  },
  CardManagementAutoPayFundingSource: {
    route: '/main/(tabs)/card/card-management/payment/autoPay/fundingSource',
    name: 'Card Management - Auto Pay - Funding Source',
    availableForDeepLinking: false,
  },
  CardManagementAutoPayConfirmation: {
    route: '/main/(tabs)/card/card-management/payment/autoPay/confirmation',
    name: 'Card Management - Auto Pay - Confirmation',
    availableForDeepLinking: false,
  },
  CardManagementAutoPayAgreement: {
    route: '/main/(tabs)/card/card-management/payment/autoPay/agreement',
    name: 'Card Management - Auto Pay - Agreement',
    availableForDeepLinking: false,
  },
  CardManagementAutoPaySuccessful: {
    route: '/main/(tabs)/card/card-management/payment/autoPay/paymentSuccessful',
    name: 'Card Management - Auto Pay - Successful',
    availableForDeepLinking: false,
  },
  CardManagementAutoPayReview: {
    route: '/main/(tabs)/card/card-management/payment/autoPay/reviewAutoPay',
    name: 'Card Management - Auto Pay - Review',
    availableForDeepLinking: false,
  },
} as const satisfies Record<string, RouteInterface>
